import { notify } from "../lib/utils";
import { auth } from "./config";
import {
  Auth,
  getIdToken,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";

export async function getFBToken() {
  try {
    if (!auth.currentUser) return null;
    const token = await getIdToken(auth.currentUser);

    return token;
  } catch (error) {
    return null;
  }
}

export const signInWithEmail = (
  auth: Auth,
  email: string,
  password: string,
  loadingStateSetter: (loading: boolean) => void
) => {
  if (loadingStateSetter) loadingStateSetter(true);

  signInWithEmailAndPassword(auth, email, password)
    .then(() => {
      if (loadingStateSetter) loadingStateSetter(false);
      return true;
    })
    .catch((error) => {
      var errorMessage = error.message;
      console.log(errorMessage);
      if (loadingStateSetter) loadingStateSetter(false);
      notify({
        type: "error",
        message: errorMessage,
      });
    });
};

export const logOut = (auth: Auth) => {
  signOut(auth).catch((error) => {
    var errorMessage = error.message;
    console.log(errorMessage);
    notify({
      type: "error",
      message: "Error logging out",
    });
  });
};
